import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Supplier } from '@stone/interfaces';

interface SuppliersState {
  items: Supplier[];
  totalCount: number;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: SuppliersState = {
  items: [],
  totalCount: 0,
  loading: false,
  saving: false,
  error: null,
};

const suppliersSlice = createSlice({
  name: 'stone.suppliers',
  initialState,
  reducers: {
    fetchSuppliersRequest: (state, _action: PayloadAction<any | undefined>) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuppliersSuccess: (state, action: PayloadAction<{ items: Supplier[]; totalCount: number }>) => {
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
      state.loading = false;
    },
    fetchSuppliersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveSupplierRequest: (state, _action: PayloadAction<any>) => {
      state.saving = true;
      state.error = null;
    },
    saveSupplierSuccess: (state) => {
      state.saving = false;
    },
    saveSupplierFailure: (state, action: PayloadAction<string>) => {
      state.saving = false;
      state.error = action.payload;
    },
    deleteSupplierRequest: (state, _action: PayloadAction<number>) => {
      state.saving = true;
      state.error = null;
    },
    deleteSupplierSuccess: (state) => {
      state.saving = false;
    },
    deleteSupplierFailure: (state, action: PayloadAction<string>) => {
      state.saving = false;
      state.error = action.payload;
    },
    toggleSupplierActiveRequest: (state, _action: PayloadAction<Supplier>) => {
      state.saving = true;
      state.error = null;
    },
    toggleSupplierActiveSuccess: (state, action: PayloadAction<Supplier>) => {
      state.saving = false;
      const idx = state.items.findIndex((s) => s.entity_id === action.payload.entity_id);
      if (idx !== -1) {
        state.items[idx] = { ...state.items[idx], is_active: action.payload.is_active };
      }
    },
    toggleSupplierActiveFailure: (state, action: PayloadAction<string>) => {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSuppliersRequest,
  fetchSuppliersSuccess,
  fetchSuppliersFailure,
  saveSupplierRequest,
  saveSupplierSuccess,
  saveSupplierFailure,
  deleteSupplierRequest,
  deleteSupplierSuccess,
  deleteSupplierFailure,
  toggleSupplierActiveRequest,
  toggleSupplierActiveSuccess,
  toggleSupplierActiveFailure,
} = suppliersSlice.actions;
export default suppliersSlice.reducer;
